import { CERTIFICATION_FRAGMENT } from 'apollo/fragments/certification-fragments';
import gql from 'graphql-tag';

export const CERTIFICATION_QUERY = gql`
  query Certifications(
    $filter: CertificationFilter
    $sort: [CertificationSort!]
    $first: Int
    $pageNumber: Int
    $after: String
  ) {
    certifications(filter: $filter, sort: $sort, first: $first, pageNumber: $pageNumber, after: $after) {
      ...CertificationFragment
      cursor
    }
  }
  ${CERTIFICATION_FRAGMENT}
`;
